import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  class: "main_content",
  id: "mainContent"
}
const _hoisted_2 = {
  class: "preview",
  id: "editor-preview"
}
const _hoisted_3 = { class: "question_title" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { style: {"float":"right","display":"flex"} }
const _hoisted_6 = { class: "status" }
const _hoisted_7 = { class: "percent" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = {
  key: 0,
  class: "test_info",
  style: {"padding-top":"20px"}
}
const _hoisted_12 = {
  key: 1,
  class: "test_info"
}
const _hoisted_13 = { class: "test_left" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = {
  key: 1,
  style: {"color":"red"}
}
const _hoisted_18 = ["disabled"]
const _hoisted_19 = ["disabled"]

import { computed, watch, onUpdated, nextTick, ref } from 'vue'
import { useStore } from 'vuex'
import QuestionContent from './QuestionContentComponent.vue'
import AnswerItem from '../../../common/AnswerItem'
import { IAnswerItem, IQuestion } from '../../../types'
import { IAnswer } from '../types'
import { getGroupQuestion, checkAnsweredGroup, checkBlankGroupQuestion } from '../../../lib/group-question'


export default /*@__PURE__*/_defineComponent({
  __name: 'QuestionGroupComponent',
  setup(__props) {

const store = useStore()

// State & Getters
const currentQuestions = computed(() => store.getters['Exam/currentQuestions'] as IQuestion<IAnswerItem>[])
const totalQuestionGroup = computed(() => store.getters['Exam/totalQuestionGroup'] as number)
const currentQuestionIndex = computed(() => store.state.Exam.currentQuestionIndex as number)
const questions = computed(() => store.state.Exam.questions as IQuestion<IAnswerItem>[])
const answers = computed(() => store.state.Exam.answers as IAnswer[])
const timer = computed(() => store.state.Exam.timer as number)

// Actions & Mutations
const submit = () => store.dispatch('Exam/submit')
const changeQuestion = (payload: { index: number }) => store.dispatch('Exam/changeQuestion', payload)
const nextQuestionMutation = () => store.commit('Exam/nextQuestion')
const showQuestion = (payload: { index: number }) => store.commit('Exam/showQuestion', payload)
const prevQuestion = () => store.commit('Exam/prevQuestion')

// Template refs
const question_content = ref<any[]>([])

// Computed
const groupQuestions = computed(() => getGroupQuestion(questions.value))

const blankQuestion = computed(() => isBlankGroupQuestion(currentQuestions.value))

const isSubmitPage = computed(() => currentQuestionIndex.value >= totalQuestionGroup.value)

const questionTitle = computed(() => {
  const quesiton_group = groupQuestions.value[currentQuestionIndex.value]
  const question_num = quesiton_group && (quesiton_group as any).question_index
  if (question_num)
    return "問題" + question_num
  else if (!isSubmitPage.value)
    return "説明"
  else
    return "テストの提出"
})

const questionTotal = computed(() => {
  let total = 0
  const gQuestions = groupQuestions.value
  for (let i = 0; i < gQuestions.length; i++) {
    const groupQuestion = gQuestions[i] as any
    if (!isBlankGroupQuestion(groupQuestion.questions)) {
      total += 1
    }
  }
  return total
})

const answeredTotal = computed(() => {
  let total = 0
  const gQuestions = groupQuestions.value
  for (let i = 0; i < gQuestions.length; i++) {
    const groupQuestion = gQuestions[i] as any
    if (checkAnsweredGroup(groupQuestion.questions, answers.value)) {
      total += 1
    }
  }
  return total
})

const answeredRate = computed(() => {
  if (questionTotal.value == 0) return 100
  return Number(answeredTotal.value / questionTotal.value * 100)
})

// Methods
const isBlankGroupQuestion = (questions: IQuestion<IAnswerItem>[]): boolean => {
  return checkBlankGroupQuestion(questions)
}

const isAnsweredGroup = (questions: IQuestion<IAnswerItem>[]): boolean => {
  return checkAnsweredGroup(questions, answers.value)
}

const answerQuestion = () => {
  const components = question_content.value
  const componentPromises: Promise<any>[] = []
  const oldQuestionIndex = currentQuestionIndex.value
  for (let index in components) {
    componentPromises.push(components[index].answerQuestion())
  }
  Promise.all(componentPromises).then(() => {
    if (currentQuestionIndex.value == oldQuestionIndex) nextQuestionMutation()
  })
  nextQuestionMutation()
}

const nextQuestionEvent = () => {
  if (!isSubmitPage.value) {
    changeQuestion({ index: currentQuestionIndex.value + 1 })
  }
}

// Lifecycle
onUpdated(() => {
  nextTick(() => {
    window.onpopstate = () => {
      const current_question = location.href.split("-").pop()
      if (!isNaN(Number(current_question))) {
        showQuestion({ index: Number(current_question) })
      }
    }
    const elm = window.document.querySelector("#mainContent") as Element
    if (elm) {
      if (window.document.querySelector(".custom-ckeditor")) {
        elm.setAttribute("style", `height: auto`)
      } else {
        const topHeight = elm.getBoundingClientRect().top + 100
        elm.setAttribute("style", `height: calc(100vh - ${topHeight}px)`)
      }
    }
  })
})

// Watch
watch(currentQuestions, () => {
  nextTick(() => {
    const components = question_content.value
    for (let index in components) {
      components[index].fillValue()
    }
    const editorPreview = document.getElementById("editor-preview")
    if (editorPreview) {
      const forms = editorPreview.getElementsByTagName("form")
      Array.from(forms).forEach((form) => {
        form.addEventListener("submit", function(event) {
          event.preventDefault()
        }, false)
      })
    }
  })
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, _toDisplayString(questionTitle.value), 1 /* TEXT */),
          _createElementVNode("div", _hoisted_5, [
            _cache[3] || (_cache[3] = _createElementVNode("div", {
              id: "example-timer",
              style: {"display":"none"}
            }, null, -1 /* CACHED */)),
            _cache[4] || (_cache[4] = _createElementVNode("span", {
              class: "percent-title",
              id: "time-left",
              style: {"margin-right":"20px","display":"none"}
            }, null, -1 /* CACHED */)),
            _cache[5] || (_cache[5] = _createElementVNode("span", { class: "percent-title" }, " 回答率 ", -1 /* CACHED */)),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", {
                class: "status-percent",
                style: _normalizeStyle({width: `${answeredRate.value.toFixed(2)}%`})
              }, null, 4 /* STYLE */)
            ]),
            _createElementVNode("div", _hoisted_7, _toDisplayString(answeredRate.value.toFixed(2)) + " % ", 1 /* TEXT */)
          ])
        ]),
        (!isSubmitPage.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentQuestions.value, (currentQuestion) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: currentQuestion.id,
                  class: "question-body-preview"
                }, [
                  _createVNode(QuestionContent, {
                    currentQuestion: currentQuestion,
                    currentQuestionIndex: currentQuestionIndex.value,
                    ref_for: true,
                    ref_key: "question_content",
                    ref: question_content
                  }, null, 8 /* PROPS */, ["currentQuestion", "currentQuestionIndex"])
                ]))
              }), 128 /* KEYED_FRAGMENT */)),
              (currentQuestionIndex.value > -1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    (!blankQuestion.value)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "btn btn-primary next-answer",
                          type: "button",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (answerQuestion()))
                        }, "回答する"))
                      : (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          class: "btn btn-primary next-answer",
                          type: "button",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (nextQuestionMutation()))
                        }, "次へ"))
                  ]))
                : _createCommentVNode("v-if", true)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_10, [
              (answeredTotal.value == questionTotal.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, " 未回答の問題がありません "))
                : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createElementVNode("div", null, "未回の答問題が" + _toDisplayString(questionTotal.value - answeredTotal.value) + "問あります", 1 /* TEXT */),
                    _createElementVNode("div", null, [
                      _cache[6] || (_cache[6] = _createTextVNode("回答率 ", -1 /* CACHED */)),
                      _createElementVNode("span", _hoisted_13, _toDisplayString(answeredRate.value.toFixed(2)) + " %", 1 /* TEXT */)
                    ]),
                    (timer.value!=0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                          _cache[7] || (_cache[7] = _createElementVNode("h3", null, "未回答の問題", -1 /* CACHED */)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupQuestions.value, (question_group, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "test-left-list",
                              key: index
                            }, [
                              (!isAnsweredGroup((question_group as any).questions) && !isBlankGroupQuestion((question_group as any).questions))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                    _createElementVNode("a", {
                                      onClick: ($event: any) => (changeQuestion({index: Number(index)}))
                                    }, " 問題 " + _toDisplayString((question_group as any).question_index), 9 /* TEXT, PROPS */, _hoisted_16)
                                  ]))
                                : _createCommentVNode("v-if", true)
                            ]))
                          }), 128 /* KEYED_FRAGMENT */))
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_17, " 回答時間が切りました。 "))
                  ])),
              _createElementVNode("a", {
                onClick: _cache[2] || (_cache[2] = ($event: any) => (submit())),
                class: "submit-btn btn-lg btn-warning btn btn-primary next-answer"
              }, "テストを提出する")
            ]))
      ])
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("a", {
        class: "btn btn-default back",
        disabled: currentQuestionIndex.value<=0,
        onClick: prevQuestion
      }, "< 前の問題", 8 /* PROPS */, _hoisted_18),
      _createElementVNode("a", {
        class: "btn btn-primary next-answer next",
        disabled: isSubmitPage.value,
        onClick: nextQuestionEvent
      }, "次の問題 >", 8 /* PROPS */, _hoisted_19)
    ])
  ]))
}
}

})